import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { InAppNotification } from './InAppNotification';
const NotificationContext = createContext(undefined);
export const useNotifications = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotifications must be used within a NotificationProvider');
    }
    return context;
};
export const NotificationProvider = ({ children, }) => {
    const [notifications, setNotifications] = useState([]);
    useEffect(() => {
        const handleInAppNotification = (event) => {
            const { title, body, type } = event.detail;
            showNotification({ title, body, type });
        };
        window.addEventListener('show-in-app-notification', handleInAppNotification);
        return () => {
            window.removeEventListener('show-in-app-notification', handleInAppNotification);
        };
    }, []);
    const showNotification = (notification) => {
        const id = `notification-${Date.now()}-${Math.random()}`;
        const newNotification = {
            ...notification,
            id,
            onClose: () => removeNotification(id),
        };
        setNotifications(prev => [...prev, newNotification]);
    };
    const removeNotification = (id) => {
        setNotifications(prev => prev.filter(notification => notification.id !== id));
    };
    return (_jsxs(NotificationContext.Provider, { value: { showNotification }, children: [children, _jsx("div", { className: "fixed top-0 right-0 z-[9999] space-y-2 p-4", style: {
                    position: 'fixed',
                    top: '0',
                    right: '0',
                    zIndex: 9999,
                    padding: '1rem',
                    pointerEvents: 'none'
                }, children: notifications.map(notification => (_jsx("div", { style: { pointerEvents: 'auto' }, children: _jsx(InAppNotification, { title: notification.title, body: notification.body, type: notification.type, duration: notification.duration, onClose: notification.onClose, onAction: notification.onAction }) }, notification.id))) })] }));
};
